<template>
  <v-row
    justify="center"
    align="center"
    v-if="isPageLoading"
    v-show="showPageLoading"
    class="text-center my-2"
  >
    <v-col
      cols="12"
      class="text-center"
    >
      <v-progress-circular
        indeterminate
        :size="50"
        class="primary--text"
      />
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'PageLoading',
  props: {
    isPageLoading: {
      type: Boolean,
      default: false
    },
    showPageLoading: {
      type: Boolean,
      default: true
    }
  }
}
</script>
